export interface ConfigString {
  [key: string]: string;
}

// Function to get the environment from process.env
export function getEnvironment(): string {
  const env = process.env.REACT_APP_ENV_NAME || 'localhost';
  if (!['localhost', 'dev', 'prod'].includes(env)) {
    throw new Error(`Unknown environment: ${env}`);
  }
  return env;
}

const BASE_API_URLS: ConfigString = {
  localhost: 'https://api.wallscapes.ai/dev', // override with localhost and port if running backend locally
  dev: 'https://api.wallscapes.ai/dev',
  prod: 'https://api.wallscapes.ai/prod'
};

export const getBaseApiUrl = () => {
  const environment = getEnvironment();
  return BASE_API_URLS[environment];
};

const BASE_APP_URLS: ConfigString = {
  localhost: 'http://localhost:3000',
  dev: 'https://dev.wallscapes.ai',
  prod: 'https://wallscapes.ai',
};

/**
 * Get the Base URL for the app
 */
export const getBaseAppUrl = () => {
  const environment = getEnvironment();
  return BASE_APP_URLS[environment];
};


const STRIPE_PUBLIC_KEYS: ConfigString = {
  localhost: 'pk_test_51RpbQaS6umhOg55mp449H8NTVoLWeg5ZfaKMSnNloOy7kMuya1dEUOLQtqb0Map6e3gUnkFHLlQzjw6soEQrRQ7F00BoSG2LFT',
  dev: 'pk_test_51RpbQaS6umhOg55mp449H8NTVoLWeg5ZfaKMSnNloOy7kMuya1dEUOLQtqb0Map6e3gUnkFHLlQzjw6soEQrRQ7F00BoSG2LFT',
  prod: 'pk_live_fvSDDJsyhUhHyPXsc8xbKjl0'
};

export const getPaymentPublicKey = () => {
  const environment = getEnvironment();
  return STRIPE_PUBLIC_KEYS[environment];
};

const GOOGLE_ANALYTICS_IDS: ConfigString = {
  localhost: 'G-8T0JZE0JGZ',
  dev: 'G-8T0JZE0JGZ',
  prod: 'G-8T0JZE0JGZ'
};

export const getGoogleAnalyticsId = () => {
  const environment = getEnvironment();
  return GOOGLE_ANALYTICS_IDS[environment];
};

const GTM_IDS: ConfigString = {
  localhost: 'GTM-TD2VCHX3',
  dev: 'GTM-TD2VCHX3',
  prod: 'GTM-TD2VCHX3'
};

export const getGTMId = () => {
  const environment = getEnvironment();
  return GTM_IDS[environment];
};